import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBqjYXD9QtMe3BUbhIPQAWy8B0YfFTp6xY",
  authDomain: "limani-ea2d1.firebaseapp.com",
  projectId: "limani-ea2d1",
  storageBucket: "limani-ea2d1.firebasestorage.app",
  appId: "1:941027554188:web:3e816daf44700d21e15ca9",
  databaseURL: "https://limani-ea2d1-default-rtdb.asia-southeast1.firebasedatabase.app"
};

console.log("Initializing Firebase with config:", firebaseConfig);
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
console.log("Firebase Auth initialized");
export const db = getFirestore(app);
export const rtdb = getDatabase(app);
export const functions = getFunctions(app);
